import PropTypes from 'prop-types'
import ButtonCta from '@components/atoms/button-cta'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import RenderRichText from '@components/renderers/render-rich-text'
import { useEffect, useState } from 'react'
import useResizeObserver from '@hooks/useResizeObserver'
import useStyles from './scenic-accordion-item-variant.styles'

const ScenicAccordionItemVariant = (props) => {
  const {
    accordionDetailHeading,
    accordionDetailLongBlurb,
    firstDetailHeadline,
    firstDetailBlurb,
    secondDetailHeadline,
    secondDetailBlurb,
    richTextBlurb,
    lowerDetailHeadline,
    lowerDetailSubtitle,
    accordionDetailCtaLabel,
    accordionDetailCtaLink,
    backgroundImage,
  } = props

  const [ref, entry] = useResizeObserver()
  const [offset, setOffset] = useState(0)

  const styles = useStyles({ offset })
  useEffect(() => {
    if (entry?.contentRect?.height) {
      setOffset(entry.contentRect.height)
    }
  }, [entry?.contentRect?.height])

  return (
    <div className={styles.scenicAccordionItem}>
      <div className={styles.bgImageContainer}>
        {backgroundImage && backgroundImage.url && (
          <img
            className={styles.bgImage}
            src={backgroundImage.url}
            alt={backgroundImage.description}
          />
        )}
      </div>
      <div className={styles.saiCardContainer}>
        <Box sx={{ p: 3 }} className={styles.saiCard}>
          <Box className={styles.top}>
            <Typography variant="h3" className={styles.tabPanelHeading}>
              {accordionDetailHeading}
            </Typography>
            <Typography className={styles.tabPanelsupportiveCopy}>
              {accordionDetailLongBlurb}
            </Typography>
          </Box>
          <Box className={richTextBlurb ? `${styles.middle} ${styles.richTextWrapper}` : `${styles.middle}`}>
            {richTextBlurb
              ? (
                <RenderRichText {...richTextBlurb} />
              )

              : (
                <>
                  <Box className={styles.left}>
                    <Typography variant="h6">{firstDetailHeadline}</Typography>
                    <Typography variant="body1">{firstDetailBlurb}</Typography>
                  </Box>
                  <Box className={styles.right}>
                    <Typography variant="h6">{secondDetailHeadline}</Typography>
                    <Typography variant="body1">{secondDetailBlurb}</Typography>
                  </Box>
                </>
              )
            }
          </Box>
          <Box ref={ref} className={styles.bottom}>
            <Box className={styles.bottomText}>
              <Typography variant="body1">{lowerDetailHeadline}</Typography>
              <RenderRichText {...lowerDetailSubtitle} />
            </Box>
            <ButtonCta
              variant="text"
              arrow
              href={accordionDetailCtaLink}
              className={styles.ctaButton}
            >
              {accordionDetailCtaLabel}
            </ButtonCta>
          </Box>
        </Box>
      </div>
    </div>
  )
}

ScenicAccordionItemVariant.propTypes = {
  index: PropTypes.number,
  accordionTitle: PropTypes.string,
  accordionDetailList: PropTypes.array,
  accordionDetailBlurb: PropTypes.string,
  accordionDetailCtaLink: PropTypes.string,
  accordionDetailCtaLabel: PropTypes.string,
  backgroundImage: PropTypes.object,
  accordionDetailHeading: PropTypes.string,
  accordionDetailLongBlurb: PropTypes.string,
  firstDetailHeadline: PropTypes.string,
  firstDetailBlurb: PropTypes.string,
  secondDetailHeadline: PropTypes.string,
  secondDetailBlurb: PropTypes.string,
  richTextBlurb: PropTypes.object,
  lowerDetailHeadline: PropTypes.string,
  lowerDetailSubtitle: PropTypes.object,
}

ScenicAccordionItemVariant.defaultProps = {}

export default ScenicAccordionItemVariant
